import { Tag } from "antd";
import { CSSProperties } from "react";
import { PaymentOutboxStatus } from "../models/payment-outbox.model";

export function paymentOutboxStatusPipe(status: number | null | undefined): string {
    switch (status) {
        case PaymentOutboxStatus.Pending: return "Đang chờ";
        case PaymentOutboxStatus.Processing: return "Đang xử lý";
        case PaymentOutboxStatus.Done: return "Hoàn thành";
        case PaymentOutboxStatus.Dead: return "Lỗi";
    }
    return "Không rõ";
}

export function paymentOutboxStatusTagPipe(
    status: number | null | undefined,
    style?: CSSProperties
) {
    const baseStyle: CSSProperties = {
        width: "100%",
        minWidth: "110px",
        textAlign: "center",
        margin: "0px",
        ...style,
    };
    switch (status) {
        case PaymentOutboxStatus.Pending:
            return <Tag color="var(--warning-button)" style={baseStyle}><b>{paymentOutboxStatusPipe(status)}</b></Tag>;
        case PaymentOutboxStatus.Processing:
            return <Tag color="var(--primary-button)" style={baseStyle}><b>{paymentOutboxStatusPipe(status)}</b></Tag>;
        case PaymentOutboxStatus.Done:
            return <Tag color="var(--success-button)" style={baseStyle}><b>{paymentOutboxStatusPipe(status)}</b></Tag>;
        case PaymentOutboxStatus.Dead:
            return <Tag color="var(--danger-button)" style={baseStyle}><b>{paymentOutboxStatusPipe(status)}</b></Tag>;
    }
    return <Tag color="default" style={baseStyle}><b>{paymentOutboxStatusPipe(status)}</b></Tag>;
}
